import { gql } from '@apollo/client';

const ADMIN_USER_SUMMARY_FRAGMENT = gql`
  fragment AdminUserSummaryFields on AdminUserSummary {
    userId
    displayName
    email
    phone
    picture
    role
    created
    providers {
      type
      credentialId
      created
    }
    firebaseUid
    firebaseEmail
    firebaseEmailVerified
    firebaseDisabled
  }
`;

export const SEARCH_USERS_FOR_RECOVERY = gql`
  query adminSearchUsersForRecovery($input: AdminSearchUsersInput!) {
    adminSearchUsersForRecovery(input: $input) {
      users {
        ...AdminUserSummaryFields
      }
    }
  }
  ${ADMIN_USER_SUMMARY_FRAGMENT}
`;

export const ADMIN_LINK_EMAIL_CREDENTIAL = gql`
  mutation adminLinkEmailCredential($input: AdminLinkEmailCredentialInput!) {
    adminLinkEmailCredential(input: $input) {
      success
      message
      user {
        ...AdminUserSummaryFields
      }
    }
  }
  ${ADMIN_USER_SUMMARY_FRAGMENT}
`;

export const ADMIN_SEND_SIGN_IN_LINK = gql`
  mutation adminSendSignInLinkToUser($input: AdminSendSignInLinkInput!) {
    adminSendSignInLinkToUser(input: $input) {
      success
      message
      sentToEmail
    }
  }
`;
